import axios from "axios";
import Student from "@/models/student";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_STUDENT_URL = process.env.VUE_APP_API_URL+"/students";

export default class StudentController {
  static async fetchAllStudents() {
      const response = await axios.get(`${API_STUDENT_URL}/get_students`);
      return response.data.map(s => new Student(s));
  }

  // Fetch student by UCO
  static async fetchStudentByUCO(uco) {
      const response = await axios.get(`${API_STUDENT_URL}/get_student_by_uco/${uco}`);
      return new Student(response.data);
  }

  // Transder student results
  static async transferResultsForStudents(list_of_students_ucos) {
      console.log("List of ucos:", list_of_students_ucos);
      const response = await axios.post(`${API_STUDENT_URL}/transmit_results_for_selected_students`, list_of_students_ucos);
      console.log("Results transfer - send successfully:", response.data);
      return response.data;
  }

  // Transder all students results
  static async transferResultsForAllStudents() {
      const response = await axios.post(`${API_STUDENT_URL}/transmit_results_for_all_students`);
      console.log("Results transfer - send successfully:", response.data);
      return response.data;
  }
    
  // Generate and download csv of results
  static async generateAndDownloadCSV(list_of_students_ucos = []) {
    console.log("List of ucos:", list_of_students_ucos);
    const response = await axios.post(`${API_STUDENT_URL}/generate_results_csv`, list_of_students_ucos, {
      responseType: 'blob'
    });
    return response;
  }

  // Download list of non-archived student UCOs
  static async downloadStudentsUcos() {
    const API_FILE_URL = process.env.VUE_APP_API_URL + "/files";
    const response = await axios.get(`${API_FILE_URL}/download_students_ucos`, {
      responseType: 'blob'
    });
    return response;
  }

  // F10: fetch all students for a semester (server-side filter)
  static async fetchAll(semesterId) {
    const response = await axios.get(`${API_STUDENT_URL}/by_semester/${semesterId}`);
    return response.data;
  }

  // F10: full student context for teacher detail view (D47)
  static async fetchStudentWithContext(uco, semesterId) {
    const response = await axios.get(`${API_STUDENT_URL}/with_context`, {
      params: { uco, semester_id: semesterId },
    });
    return response.data;
  }

  // F10: progress summary for a single student (used by StudentTeacherView)
  static async fetchProgressSummary(uco, semesterId) {
    const response = await axios.get(`${API_STUDENT_URL}/progress_summary`, {
      params: { uco, semester_id: semesterId },
    });
    return response.data;
  }

  // F10: batch progress summaries for all students in a semester (used by StudentPage)
  static async fetchProgressSummaries(semesterId) {
    const response = await axios.get(`${API_STUDENT_URL}/progress_summaries`, {
      params: { semester_id: semesterId },
    });
    return response.data;
  }
}

applyErrorHandlers(StudentController);
